import ListStore from '@/store/core/ListStore';
import { action, computed, observable, override } from 'mobx';
import services from '@/api/services';
import { dateFormat, numGroup } from '@/utils/filters';
import { IIncomeReceipt } from '@/store/types';

export default class TaxpayersStore extends ListStore<{
  receipts: Array<IIncomeReceipt>;
  totalSumReceipt: number;
  count: number;
}> {
  @override
  filters = {
    month: '2023-05',
    status: '',
    source: '',
  };
  @observable overall = {
    totalSumReceipt: 0,
  };
  @observable currentTaxpayer = '';
  @observable totalPages = 0;

  sortColumns: (keyof IIncomeReceipt)[] = ['date', 'sumReceipt'];

  @computed get processedData() {
    if (!this.data?.receipts || !this.data?.receipts?.length) return;
    const items: any[] = this.data.receipts.map((item) => ({
      ...item,
      date: dateFormat(item.date, {
        format: 'DD.MM.YYYY',
        addHours: 0,
      }),
      sumReceipt: numGroup(item.sumReceipt),
    }));
    items.unshift({
      numReceipt: 'ИТОГО',
      sumReceipt: this.data?.totalSumReceipt.toLocaleString('Ru-ru'),
      isSummary: true,
    });
    return {
      ...this.data,
      items,
      ...this.pageable,
      totalPages: this.totalPages,
    };
  }

  @action.bound async fetch() {
    this.isFetching = true;
    try {
      const { data } = await services.platforms.getTaxpayerIncome(
        this.currentTaxpayer,
        this.notFalsyParams,
      );
      this.data = data;
      this.totalPages = data.totalPages;
      this.overall = {
        totalSumReceipt: data.totalSumReceipt,
      };
    } catch (e) {
      console.error(e);
    } finally {
      this.isFetching = false;
    }
  }
}
